/**
 * MUSKLE Points Shop — client-side search / sort / category filters.
 * Operates on rendered .muskle-points-shop__item cards only.
 * Does not touch redeem / cash-redeem form logic.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function normalize(str) {
    return String(str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  function initShop(root) {
    var search = root.querySelector('#mps-search');
    var sort = root.querySelector('#mps-sort');
    var chips = root.querySelectorAll('[data-mps-filter-chip]');
    var grid = root.querySelector('.muskle-points-shop__grid');
    var empty = root.querySelector('#mps-filter-empty');
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll('.muskle-points-shop__item'));
    if (!items.length) return;

    // Preserve initial DOM order for "recommended"
    items.forEach(function (item, index) {
      if (!item.hasAttribute('data-mps-dom-index')) {
        item.setAttribute('data-mps-dom-index', String(index));
      }
    });

    var state = {
      query: '',
      category: 'alles',
      sort: 'recommended'
    };

    function itemText(item) {
      var title = item.getAttribute('data-mps-title') || '';
      var cats = item.getAttribute('data-mps-categories') || '';
      var desc = '';
      var benefit = item.querySelector('.muskle-points-shop__card-benefit');
      var catEl = item.querySelector('.muskle-points-shop__card-cat');
      var source = item.querySelector('.muskle-points-shop__card-source');
      if (benefit) desc += ' ' + benefit.textContent;
      if (catEl) desc += ' ' + catEl.textContent;
      if (source) desc += ' ' + source.textContent;
      return normalize(title + ' ' + cats + ' ' + desc);
    }

    function matchesCategory(item, category) {
      if (!category || category === 'alles') return true;
      var cats = normalize(item.getAttribute('data-mps-categories') || '');
      var tokens = cats.split(/\s+/).filter(Boolean);
      return tokens.indexOf(normalize(category)) !== -1;
    }

    function matchesSearch(item, query) {
      if (!query) return true;
      return itemText(item).indexOf(normalize(query)) !== -1;
    }

    function sortItems(list, mode) {
      var sorted = list.slice();
      sorted.sort(function (a, b) {
        if (mode === 'points-asc' || mode === 'points-desc') {
          var pa = parseInt(a.getAttribute('data-mps-points') || '0', 10) || 0;
          var pb = parseInt(b.getAttribute('data-mps-points') || '0', 10) || 0;
          if (pa !== pb) return mode === 'points-asc' ? pa - pb : pb - pa;
        }
        if (mode === 'name-az') {
          var ta = normalize(a.getAttribute('data-mps-title') || '');
          var tb = normalize(b.getAttribute('data-mps-title') || '');
          if (ta < tb) return -1;
          if (ta > tb) return 1;
        }
        // recommended: preserve original template/DOM order
        var ia = parseInt(a.getAttribute('data-mps-dom-index') || '0', 10) || 0;
        var ib = parseInt(b.getAttribute('data-mps-dom-index') || '0', 10) || 0;
        return ia - ib;
      });
      return sorted;
    }

    function apply() {
      var visible = [];
      items.forEach(function (item) {
        var show = matchesSearch(item, state.query) && matchesCategory(item, state.category);
        item.classList.toggle('is-mps-hidden', !show);
        if (show) visible.push(item);
      });

      var ordered = sortItems(visible, state.sort);
      ordered.forEach(function (item) {
        grid.appendChild(item);
      });
      // Keep hidden items after visible ones to preserve relative order when re-shown
      items.forEach(function (item) {
        if (item.classList.contains('is-mps-hidden')) {
          grid.appendChild(item);
        }
      });

      if (empty) {
        empty.classList.toggle('is-visible', visible.length === 0);
        empty.hidden = visible.length !== 0;
      }
    }

    if (search) {
      search.addEventListener('input', function () {
        state.query = search.value || '';
        apply();
      });
    }

    if (sort) {
      sort.addEventListener('change', function () {
        state.sort = sort.value || 'recommended';
        apply();
      });
    }

    // Hide category chips with zero matching cards (keep "Alles")
    chips.forEach(function (chip) {
      var value = chip.getAttribute('data-mps-filter-chip') || 'alles';
      if (value === 'alles') return;
      var count = items.filter(function (item) {
        return matchesCategory(item, value);
      }).length;
      chip.hidden = count === 0;
      chip.style.display = count === 0 ? 'none' : '';
    });

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var value = chip.getAttribute('data-mps-filter-chip') || 'alles';
        state.category = value;
        chips.forEach(function (c) {
          var active = c === chip;
          c.setAttribute('aria-pressed', active ? 'true' : 'false');
          c.classList.toggle('is-active', active);
        });
        apply();
      });
    });

    apply();
  }

  ready(function () {
    var shops = document.querySelectorAll('.muskle-points-shop');
    shops.forEach(initShop);
  });
})();
